export interface IFilterAndPaginationFieldsBase {
  page: number | null;
  size: number | null;
}
